import { Status } from '@/common/enums/Status';
import type { DEFAULT_PARAMETERS } from './bag-reservation-list-config';
import { TransportKind } from '@/common/enums/TransportKind';

export interface BagReservationListData {
	id: string;
	statusId: string;
	reservationTime: string;
	expirationTime: string;
	canceledAt: string;
	time: {
		lower: string;
		upper: string;
	};
	currencyId: number;
	countPerson: number;
	promotionValue: string;
	totalPrice: string;
	responsibleUserId: number;
	ownerUser: {
		firstName: string;
		lastName: string;
		userContacts: Array<{
			id: number;
			phone: string;
			email: string;
			destiny: {
				id: string;
				destiny: string;
			};
		}>;
	};
	ownerOrganization: string;
	seller: string;
	commissionValue: string;
	balance: number;
	channel: number;
	paidAmount: string;
	paymentStatus: string;
	season: string;
	nightsStay: number;
	allOffers: Array<{
		id: number;
		status: string;
		product: string;
		board: number;
		slot: Array<{
			id: number;
			userData: unknown;
			status: string;
			stopDeparture: number;
			transportDeparture: number;
			transportReturn: number;
			stopReturn: number;
		}>;
		promotion: Array<{
			id: number;
			name: string;
		}>;
		wasTransportAvailable: boolean;
		insurer: number;
		insurance: unknown;
	}>;
	number: {
		label: number;
		isLink: boolean;
		route: string;
	};
	status: {
		name: string;
		statusColor: string;
	};
	channelSeller: string;
	left2pay: string;
	responsibleUser: string;
	owner: string;
	phone: string;
	email: string;
	destination: string[];
	product: string[];
	board: string[];
	countCancelledPersons: number;
	categoryPrice: string[];
	stopDeparture: string[];
	nightsStayTotal: number;
	paymentKinds: string[];
	transportTypes: TransportKind[];
}

export interface BagReservationListFilters {
	id: number;
	owner_name: string;
	owner_phone: string;
	departure_city: number[];
	nights_min: string;
	nights_max: string;
	confirmation_time__gte: string;
	confirmation_time__lte: string;
	reservation_time__gte: string[];
	reservation_time__lte: string[];
	time_lower_after: string;
	time_lower_before: string;
	time_upper_after: string;
	time_upper_before: string;
	total_price_max: number;
	total_price_min: number;
	balance_max: number;
	balance_min: number;
	balance_without_commission_max: number;
	balance_without_commission_min: number;
	paid_amount_min: number;
	paid_amount_max: number;
	product: string[];
	payment_status: string[];
	seller: string[];
	organization: string[];
	channel: string[];
	alert: string[];
	status: Status[];
	product_kind: string[];
	responsible_user: string[];
	destination_location: string[];
	location: string[];
	service: string[];
	seller_is_oskar: string;
	offer__status: Status[];
	season: string[];
	price_adjusted: string;
	room_type: string[];
	payment_kind: string[];
	transport_types?: TransportKind[];
	on?: number;
	limit?: number;
	offset?: number;
	ordering?: string;
	voucher: string;
}

export interface ParseFilters {
	total_price_max: number;
	total_price_min: number;
	balance_max: number;
	balance_min: number;
	balance_without_commission_max: number;
	balance_without_commission_min: number;
	status: Status[];
	time_lower_before: string;
	time_upper_before: string;
	reservation_time__lte: string;
	confirmation_time__lte: string;
	time_lower_after: string;
	time_upper_after: string;
	reservation_time__gte: string;
	confirmation_time__gte: string;
	paid_amount_min: number;
	paid_amount_max: number;
	offer__status: Status[];
}

export interface StatisticsLoadBeforeData {
	filters: Status[];
	show: boolean;
	allFilters: { [key: string]: unknown };
}

export type FilterDefinition = {
	[key: string]: {
		type: 'string' | 'number' | 'boolean';
		isArray: boolean;
	};
};

export interface SelectOption {
	id: string;
	name: string | Status;
}

export interface UserOption {
	id: string;
	firstName: string;
	lastName: string;
}

export interface OptionWithShortName {
	id: string;
	shortName: string;
}

export type BagReservationListParameters = typeof DEFAULT_PARAMETERS;

export enum PaymentKinds {
	CARD = 'Karta',
	CASH = 'Gotówka',
	COMMISSION = 'Prowizja',
	PAYU = 'PayU',
	RECLASSIFICATION = 'Przeksięgowanie',
	SETTLEMENT = 'Wyrównanie',
	TRANSFER = 'Przelew',
	TPAY = 'Tpay',
	VOUCHER = 'Voucher',
}
